<template>
    <div>
        <div>
            <div style="font-size:7rem;">식단표앱 필요하세요?</div>
            <div style="font-size:2rem; color:grey">알람, 댓글, 여러 식당 선택, 자유로운 메뉴 구조 설정</div>
                 <div style="height:20px"></div>
            <div style="font-size:3rem; color:grey">이 모든게 무료입니다</div>
        </div>

        <div style="height:50px"></div>

        <div style="font-size: 1.2rem;">
            상담이 필요하신가요?
            <div>
                <a href="https://open.kakao.com/o/snxE8uCd" target="_blank" >
          

               식단표장인과 1:1 채팅
                     </a> 또는      <a href="tel:010-9307-5807">010-9307-5807</a>
            </div>
        </div>
        <div style="height:50px"></div>
        <div >
            <router-link to="/app">
                <v-btn color="blue darken-3" dark large style="height:70" @click="showSideBar">
                    <div style="font-size: 2rem;">
                        식단표 입력 시작하기
                    </div>
                </v-btn>
            </router-link>
        </div>
        <div style="height:50px"></div>

        <div class="landing-production-cards">
         
            <div >
                <v-card class="mx-auto" max-width="300">
                    <img style=" max-width:300px; " src="../assets/gune_3.jpg">
                    <v-card-text>
                        <div>여러 식당을 선택 가능합니다</div>

                    </v-card-text>
                </v-card>
            </div>
            <div >
                <v-card class="mx-auto" max-width="300">
                    <img style=" max-width:300px; " src="../assets/gune_2.jpg">
                    <v-card-text>
                        <div> 댓글 피드백을 쉽게 받을수 있습니다</div>

                    </v-card-text>

                </v-card>
            </div>
           
        </div>
         <div style="height:20px"></div>
          <div style="font-size: 1.2rem; color:grey">
         iOS, Android 스토어에 모두 등록
         <p>
             현재 14곳의 식단표앱을 운영중입니다
         </p>
         <p>
             스샷 이외의 많은 기능들은 직접 다운받으셔서 이용해보세요
         </p>
         </div>
         

    </div>
</template>

<script>
export default {
     methods: {
        showSideBar: function() {
        this.$store.state.isOpenSideBar = true;
        },
    }
}
</script>
<style scoped>
.landing-production-cards{
    display: flex;
    flex-direction: row;
    
    justify-content: space-around;
    
}
.v-btn {
    height: 80px;
}
</style>